<template>
  <!-- 返佣明细页面 -->
  <div id="agentRebateDetial">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!-- 返佣对象 -->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommission") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="returnTo" :options="returnToArr"
              :disabled="this.roleType == 0 || this.roleType == 1">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
          <!--返佣对象uid-->
          <b-form-group class="find-middle" v-if="returnTo && returnTo.value == 1" :style="{
            width: lan === 'zh_CN' || lan === 'el_GR' ? '200px' : '267px',
          }">
            <b-form-input v-model.trim="pid" maxLength="15"
              :placeholder="$t('lanV4.ReturnedCommissionUid')"></b-form-input>
          </b-form-group>
          <!--搜索uid-->
          <b-form-group class="find-middle user-id">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.searchUidTip") }}
                </div>
                <span class="el_tooltip_bor"> {{ $t("lanV4.newUid") }}</span>
              </el-tooltip>
            </label>
            <b-form-input v-model.trim="searchUid" maxLength="15" placeholder=""></b-form-input>
          </b-form-group>

          <!--订单号-->
          <!-- <b-form-group class="find-middle">
            <label>
              {{ $t("lanV4.agentOrderNum") }}
            </label>
            <b-form-input v-model.trim="searchOrderNum" maxLength="10" placeholder=""></b-form-input>
          </b-form-group> -->
          <!--返佣级别-->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionLevelTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="level" :options="levelArray">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 保证金币种 -->
          <b-form-group :label="$t('lanV4.marginCoin')" class="find-middle">
            <v-select class="find-select" v-model="symbol" :options="symbolList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 返佣状态-->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div class="tip-content" slot="content">
                  <p>{{ $t('lanV4.rebateStatusTip1') }}</p>
                  <p>{{ $t('lanV4.rebateStatusTip2') }}</p>
                  <p>{{ $t('lanV4.rebateStatusTip3') }}</p>
                  <p>{{ $t('lanV4.rebateStatusTip4') }}</p>
                </div>
                <span class="el_tooltip_bor">{{ $t("lanV4.RebateStatus") }}</span>
              </el-tooltip>
            </label>
            <v-select class="find-select" v-model="returnStatus" :options="returnStatusArr">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <b-form-group :label="$t('lanV4.tradeTime')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels type="daterange" value-format="timestamp"
              range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              @change="handleChangeDate" :clearable="true" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                  <use xlink:href="#icon-v4_17"></use>
                </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                  <use xlink:href="#icon-v4_3"></use>
                </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
            class="float-left"
            v-if="pages.total > 0"
            :total-rows="pages.total"
            :perPage="pages.size"
            :pageOptions="pages.options"
            :currentPage="pages.page"
            @initialize="pageChange"
            layout="total,sizes"
          >
          </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'totalAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!--  序号 -->
            <el-table-column prop="sort" align="left" :label="$t('common.sort')">
            </el-table-column>
            <!--  结算时间-->
            <el-table-column prop="ctime" align="right" :label="$t('lanV4.settlementTime')" width="200">
            </el-table-column>
            <!--  uid-->
            <el-table-column prop="uid" align="right" :label="$t('lanV4.newUid')" width="150">
            </el-table-column>

            <!--  返佣对象-->
            <el-table-column prop="returnTo" align="right" :label="$t('lanV4.ReturnedCommission')" width="150">
            </el-table-column>
            <!-- 返佣级别 -->
            <el-table-column prop="returnLevel" :label="$t('lanV4.ReturnedCommissionLevel')" align="right" width="150">
            </el-table-column>
            <!-- 保证金币种 -->
            <el-table-column prop="coin" align="right" :label="$t('lanV4.marginCoin')" width="150">
            </el-table-column>
            <!-- 订单号 -->
            <!-- <el-table-column prop="orderNum" align="right" :label="$t('lanV4.agentOrderNum')" width="150">
            </el-table-column> -->
            <!--  交易额 -->
            <el-table-column prop="tradeAmount" align="right" :label="$t('lanV4.ReceivedcommissionAmount')" width="150">
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.tradeAmount }}
                </span>
              </template>
            </el-table-column>

            <!--  手续费 -->
            <el-table-column prop="fee" align="right" :label="$t('lanV4.agentFee')" width="150">
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.fee }}
                </span>
              </template>
            </el-table-column>

            <!--  返佣比例 -->
            <el-table-column prop="returnScale" align="right" width="150">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.RebateRateTip") }}
                  </div>
                  <span> {{ $t("lanV4.RebateRate") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.returnScale }}
                </span>
              </template>
            </el-table-column>
            <!--  返佣金额 -->
            <el-table-column prop="returnAmount" align="right" :label="$t('')" width="150">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("lanV4.returnAmountTip") }}
                  </div>
                  <span> {{ $t("lanV4.returnAmount") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.returnAmount }}
                </span>
              </template>
            </el-table-column>

            <!--  返佣状态 -->
            <el-table-column prop="status" align="right" width="150" :label="$t('lanV4.RebateStatus')">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.status }}
                </span>
              </template>
            </el-table-column>
            <!-- 交易日期 -->
            <el-table-column prop="tradeTime" align="right" :label="$t('lanV4.tradeTime')" width="200">
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", {
              pagesTotal: pages.total,
              maxNum: exportNumLimit,
            })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime, formatTimeDay } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
export default {
  name: "agentRebateDetial",
  mixins: [commonMixin],
  components: {
    headerUpdate,
  },
  data() {
    return {
      returnTo: null, //返佣对象
      pid: null, // 返佣对象uid
      searchUid: null, // uid
      dateArray: [new Date().getTime() - 86400000 * 7, new Date().getTime()],
      beginDate: null,
      endDate: null,
      level: null, //返佣级别
      levelArray: [], //返佣级别下拉
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "totalAmount", //默认排序字段
      sortSet: 1, //默认倒序
      symbol: null,
      symbolList: [],

      returnStatus: null, //返佣状态
      // searchOrderNum: null,//订单号
    };
  },
  computed: {
    // 返佣对象
    returnToArr() {
      return [
        {
          label: this.$t("lanV4.ReturnedCommissionMy"), //我
          value: 0,
        },
        {
          label: this.$t("lanV4.ReturnedCommissionThe"), //他人
          value: 1,
        },
      ];
    },
    // 返佣状态
    returnStatusArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.RebateStatusTxt1"), //待发放
          value: 0,
        },
        {
          label: this.$t("lanV4.RebateStatusTxt2"), //冻结中
          value: 1,
        },
        {
          label: this.$t("lanV4.RebateStatusTxt4"), //已发放
          value: 2,
        },
        {
          label: this.$t("lanV4.RebateStatusTxt3"), //已回收
          value: 3,
        },
      ];
    },
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
  },
  created() {
    if (this.$route.query.btnType == "view") {
      // 返佣统计跳过来
      if (this.$route.query.returnTo == 0) {
        this.returnTo = this.returnToArr[0];
      }
      //    他人
      if (this.$route.query.returnTo == 1) {
        this.pid = this.$route.query.pid;
        this.returnTo = this.returnToArr[1];
      }
      //   上个页面列表uid
      if (this.$route.query.searchUid) {
        this.searchUid = this.$route.query.searchUid;
      }
      // 传过来的时间
      if (this.$route.query.startTime && this.$route.query.endTime) {
        this.dateArray = [
          Number(this.$route.query.startTime),
          Number(this.$route.query.endTime) + 86400000 - 1,
        ];
      }
    }

    // if (this.$route.query.btnType == "entrust") {
    //   // 普通委托跳过来
    //   if (this.$route.query.returnTo == 0) {
    //     this.returnTo = this.returnToArr[0];
    //   }
    //   // 订单号
    //   if (this.$route.query.orderId) {
    //     this.searchOrderNum = this.$route.query.orderId
    //   }
    //   // 传过来的时间
    //   this.dateArray = [];
    // }
    this.handleChangeDate();
    if (this.roleType == 0 || this.roleType == 1) {
      this.returnTo = this.returnToArr[1];
    } else {
      this.returnTo = this.returnToArr[0];
    }
    this.level = this.levelArray[0];
    this.returnStatus = this.returnStatusArr[0];
    this.getReturnLevel();
    this.getAgentSmbolList();
    this.getData();
  },
  methods: {
    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "ctime":
          return "enNum";
        case "uid":
          return "enNum";
        case "returnTo":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnScale":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },

    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 获取经纪人保证金币种
    getAgentSmbolList() {
      //   let brokerId;
      //   if (this.brokerId && this.brokerId.value) {
      //     brokerId = this.brokerId.value;
      //   } else {
      //     brokerId = null;
      //   }
      this.$http({
        url: this.$store.state.url.agent.getMarginCoinList,
        params: {
          companyId: null,
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [{ label: this.$t("common.all"), value: null }];
          if (data.coinList.length) {
            data.coinList.map((item) => {
              if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
              if (this.roleType == 3 || this.roleType == 4) {
                // 经纪人展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
            });
          }
          this.symbolList = arr;
          this.symbol = this.symbolDefaultValue();
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    //获取保证金币种默认值
    symbolDefaultValue() {
      let data = [];
      if (this.symbolList && this.symbolList.length) {
        data = this.symbolList[0];
        // this.symbolList.forEach((item) => {
        //   if (item.value === "USDT") {
        //     data = item;
        //   }
        // });
      }
      return data;
    },
    // 获取返佣级别下拉
    getReturnLevel() {
      this.$http({
        url: this.$store.state.url.agent.level_list,
        params: {
          startTime: this.dateArray
            ? new window.Date(formatTimeDay(this.beginDate)).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(formatTimeDay(this.endDate)).getTime()
            : null,
          returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
          pid: this.pid,
          uid: this.searchUid,
          returnLevel: this.level ? this.level.value : null,
          coin: this.symbol ? this.symbol.value : "",
          returnStatus: this.returnStatus ? this.returnStatus.value : null, //返佣状态（1: 待结算， 0: 已结算）
          pageNum: this.pages.page,
          pageSize: this.pages.size,
          isExport: 0,
          type:1,
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          arr.push({ label: this.$t("common.all"), value: null });
          if (data) {
            data.levelArray.map((item) => {
              arr.push({ label: item.levelName, value: item.level });
            });
            this.levelArray = arr;
            if(!this.level){
              this.level = arr[0];
            }

          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 查看
    handleView(row) {
      const queryObj = {
        returnTo: this.returnTo ? this.returnTo.value : "",
        uid: this.uid,
        listUid: row.uid,
        startTime: new window.Date(this.beginDate).getTime(),
        endTime: new window.Date(this.endDate).getTime(),
      };
      this.$router.push({ path: "/flowerQuery", query: queryObj });
    },
    // 搜索
    query() {
      // if (this.pid == null || this.pid == "") {
      //   // 请输入返佣对象的UID
      //   this.$bus.$emit("alert", {
      //     type: "error",
      //     message: this.$t("lanV4.ReturnedCommissionUid2"),
      //   });
      // } else {

      // }
      this.pages.page = 1;
      this.loading = true;
      this.getReturnLevel();
      this.getData();
    },
    // 重置
    reset() {
      if (this.roleType == 0 || this.roleType == 1) {
        // 平台和商户锁定他人
        this.returnTo = this.returnToArr[1];
      } else {
        this.returnTo = this.returnToArr[0];
      }
      this.pid = null;
      this.searchUid = null;
      this.level = this.levelArray[0];
      this.symbol = this.symbolList[0];
      this.returnStatus = this.returnStatusArr[0];
      // this.searchOrderNum = null
      this.dateArray = [
        new Date().getTime() - 86400000 * 7,
        new Date().getTime(),
      ];
      this.handleChangeDate();
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        startTime: this.dateArray
          ? new window.Date(formatTimeDay(this.beginDate)).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(formatTimeDay(this.endDate)).getTime()
          : null,
        returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
        pid: this.pid,
        uid: this.searchUid,
        returnLevel: this.level ? this.level.value : null,
        coin: this.symbol ? this.symbol.value : "",
        returnStatus: this.returnStatus ? this.returnStatus.value : null, //返佣状态（1: 待结算， 0: 已结算）
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        isExport: 0,
        // searchOrderNum: this.searchOrderNum ? this.searchOrderNum : null,//订单号
      };
      this.$http({
        url: this.$store.state.url.agent.user_bonus_list,
        params: paramsData,
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, records } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (records && records.length) {
        records.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            ctime: item.ctime ? formatTime(item.ctime) : null,
            uid: item.uid,
            returnTo: item.returnTo, //返佣对象
            returnLevel: item.returnLevel, //返佣级别
            coin: item.coin, //保证金币种
            tradeAmount: item.tradeAmount, //交易额
            fee: item.fee, //手续费
            returnScale: item.returnScale, //返佣比例
            returnAmount: item.returnAmount, //返佣金额
            status: item.status, //返佣状态
            tradeTime: item.tradeTime ? formatTimeDay(item.tradeTime) : "--", //交易日期
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          startTime: this.dateArray
            ? new window.Date(formatTimeDay(this.beginDate)).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(formatTimeDay(this.endDate)).getTime()
            : null,
          returnTo: this.returnTo ? this.returnTo.value : null, //返佣对象(0:我，1:他人)
          pid: this.pid,
          uid: this.searchUid,
          returnLevel: this.level ? this.level.value : null,
          coin: this.symbol ? this.symbol.value : "",
          returnStatus: this.returnStatus ? this.returnStatus.value : null, //返佣状态（1: 待结算， 0: 已结算）
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.user_bonus_list,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentRebateDetial {
  .custom-control {
    top: 5px !important;
  }

  .icon-wh {
    width: 12px;
    height: 12px;
    position: relative;
    top: -1px;
    left: 4px;
  }

}

.tip-content {
  text-align: left;

  p {
    margin-bottom: 8px
  }
}
</style>